


























import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component({
  name: "articleDetailType2",
})
export default class extends Vue {
  @Prop()
  articleDetail: any;

  @Watch("articleDetail", { immediate: true, deep: true })
  onarticleDetail(val: any, oldVal: any) {
    if (val) {
      // this.enterpriseMienData = val;
      // console.log('articleDetail----------s-',val)
    }
  }
  private testStr: any = ``;
}
